import { TrendColorClass } from '@shared/interfaces';

/**
 * Default color class for stats based on trend
 */
export const STAT_COLOR_CLASS: TrendColorClass = {
    up: 'text-success-main bg-success-50',
    down: 'text-danger-main bg-danger-50',
};
